<template>
  <router-view></router-view>
</template>

<script setup>
</script>

<!-- <style lang="scss" src="./style.scss"></style> -->
